"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAuthRedirectRouter = void 0;
var BrowserAuthRedirectRouter_1 = require("./router/BrowserAuthRedirectRouter");
/*
 * This function is provided exclusively for situations where the same code needs to execute on both the client and server.
 *
 * In order to prevent server-side code from being included in the client bundle, import of that code is done asynchronously.
 * This is not necessary if the correct router for the current environment is used directly.
 * If you're writing code that will only execute on either the server or the client,
 * then ignore this function and directly use the correct router.
 */
function getAuthRedirectRouter(context) {
    return __awaiter(this, void 0, void 0, function () {
        var NextAuthRedirectRouter;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (typeof window !== 'undefined' && context) {
                        throw new Error('Next context may not be supplied when in the browser.');
                    }
                    if (typeof window === 'undefined' && !context) {
                        throw new Error('Next context must be supplied when not in the browser.');
                    }
                    if (!context) return [3 /*break*/, 2];
                    return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('./router/NextAuthRedirectRouter')); })];
                case 1:
                    NextAuthRedirectRouter = (_a.sent()).NextAuthRedirectRouter;
                    return [2 /*return*/, new NextAuthRedirectRouter(context)];
                case 2: return [2 /*return*/, BrowserAuthRedirectRouter_1.browserAuthRedirectRouter];
            }
        });
    });
}
exports.getAuthRedirectRouter = getAuthRedirectRouter;
exports.default = getAuthRedirectRouter;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0QXV0aFJlZGlyZWN0Um91dGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2dldEF1dGhSZWRpcmVjdFJvdXRlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUVBLGdGQUErRTtBQUUvRTs7Ozs7OztHQU9HO0FBQ0gsU0FBc0IscUJBQXFCLENBQ3pDLE9BQW1DOzs7Ozs7b0JBRW5DLElBQUksT0FBTyxNQUFNLEtBQUssV0FBVyxJQUFJLE9BQU8sRUFBRSxDQUFDO3dCQUM3QyxNQUFNLElBQUksS0FBSyxDQUFDLHVEQUF1RCxDQUFDLENBQUM7b0JBQzNFLENBQUM7b0JBRUQsSUFBSSxPQUFPLE1BQU0sS0FBSyxXQUFXLElBQUksQ0FBQyxPQUFPLEVBQUUsQ0FBQzt3QkFDOUMsTUFBTSxJQUFJLEtBQUssQ0FBQyx3REFBd0QsQ0FBQyxDQUFDO29CQUM1RSxDQUFDO3lCQUVHLE9BQU8sRUFBUCx3QkFBTztvQkFDMEIsc0ZBQ2pDLGlDQUFpQyxRQUNsQzs7b0JBRk8sc0JBQXNCLEdBQUssQ0FBQSxTQUVsQyxDQUFBLHVCQUY2QjtvQkFHOUIsc0JBQU8sSUFBSSxzQkFBc0IsQ0FBQyxPQUFPLENBQUMsRUFBQzt3QkFHN0Msc0JBQU8scURBQXlCLEVBQUM7Ozs7Q0FDbEM7QUFuQkQsc0RBbUJDO0FBQ0Qsa0JBQWUscUJBQXFCLENBQUMifQ==


//////////////////
// WEBPACK FOOTER
// ./node_modules/@angi/auth-redirect-router/getAuthRedirectRouter.js
// module id = 4334
// module chunks = 25